import React from "react";

import RealizationTile from "components/RealizationTile";

import "./realization-masonry.scss";

const RealizationMasonry = ({ options, qty }) => {
   const tileAmount = qty - 1;
   return (
      <div className="realization-masonry">
         <div className="row">
            {options.map((item, index) =>
               qty ? (
                  index <= tileAmount && (
                     <div className="col-md-6 realization-masonry__tile" key={index}>
                        <RealizationTile
                           year={item.portfolioAcf.year}
                           image={item.portfolioAcf.mainImg?.sourceUrl}
                           title={item.title}
                           location={item.portfolioAcf.city}
                           link={item.uri}
                           logo={item.portfolioAcf.logo?.sourceUrl}
                        />
                     </div>
                  )
               ) : (
                  <div className="col-md-6 realization-masonry__tile" key={index}>
                     <RealizationTile
                        year={item.portfolioAcf.year}
                        image={item.portfolioAcf.mainImg?.sourceUrl}
                        title={item.title}
                        location={item.portfolioAcf.city}
                        link={item.uri}
                        logo={item.portfolioAcf.logo?.sourceUrl}
                     />
                  </div>
               )
            )}
         </div>
      </div>
   );
};

export default RealizationMasonry;
